// src/hooks/useEventos.js
import { useState, useEffect, useRef, useCallback } from "react";
import getRegistrosEventos from "../API/events/getRegistrosEventos";
import getAllChamados from "../API/server/getChamados";
import adaptarEventosParaUI from "../API/utils/adaptarEventos"; // <-- novo

const useEventos = () => {
  const [eventos, setEventos] = useState([]);
  const [chamados, setChamados] = useState([]);
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef(null);
  const abortRef = useRef(null);

  const carregarEventos = useCallback(async (forceReload = false) => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    try {
      if (forceReload) setLoading(true);

      const [evtResp, chamadosData] = await Promise.all([
        getRegistrosEventos(),
        getAllChamados()
      ]);

      const eventosAPI = Array.isArray(evtResp?.data) ? evtResp.data : [];
      setChamados(chamadosData || []);

      // 🔑 Aqui adaptamos para o formato que o componente espera
      const adaptados = adaptarEventosParaUI(eventosAPI, chamadosData);

      setEventos(adaptados);
      console.log(eventos[0])
    } catch (err) {
      if (err?.name !== "AbortError") console.error("Erro ao buscar eventos:", err);
    } finally {
      if (forceReload) setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregarEventos(true);
    intervalRef.current = setInterval(() => carregarEventos(false), 5000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (abortRef.current) abortRef.current.abort();
    };
  }, [carregarEventos]);

  return { eventos, chamados, loading, carregarEventos };
};

export default useEventos;
